import React from 'react'

const Page = ({pageTitle, children}) => {
    document.title = pageTitle;
    return <React.Fragment>{children}</React.Fragment>;
}

export default Page;
